import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchMain({ commit, state }) {
      if (state.data)
        return;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/mainpage/info/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
        console.error('Error fetching:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    main: state => state.data,
    mainLoading: state => state.loading,
    mainError: state => state.error,
    mainLoaded: state => state.loaded,
  }
})